import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
    Breadcrumbs, Button, Container, FormControl, FormControlLabel, ListItem, Paper, Radio, RadioGroup,
    Typography,
} from "@mui/material";
import {
    bookingActions,
    getNextStep,
    getPreviousStep,
    getStepFromUrl, isWidget,
    requestApi,
    restartBooking,
    showAlertAutoDis
} from "../../utils/utils";
import {useDispatch, useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import {setStep} from "../../redux/actions/stepActions";
import Itinerary from "../../components/Booking/DayTripBooking/Itinerary";
import ActivityBookingReview from "../../components/Booking/DayTripBooking/ActivityBookingReview";
import DayTripStepper from "../../components/Booking/DayTripBooking/DayTripStepper";
import {setBookingType} from "../../redux/actions/tripActions";
import {SET_SELECTED_EXTRAS} from "../../redux/constants/transactionConstants";
import {setTotalActivitiesFH} from "../../redux/actions/totalActions";
import {getActivityList} from "../../redux/actions/activitiesActions";
import {makeStyles} from "@mui/styles";
import {differenceInHours, format, parse} from "date-fns";
import clsx from "clsx";
import {LocalPhoneOutlined, MailOutlined, PersonOutlined} from "@mui/icons-material";
import {lightBlue} from "@mui/material/colors";
import Summary from "../../components/Booking/DayTripBooking/Summary";


const useStyles = makeStyles({
    option: {
        display: 'flex',
        padding: 14,
        '-webkit-flex-direction': 'column',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: 'auto'
    }
});
const fdd = (date) => {
    let dt = date.split("-");
    const nd = new Date(dt[0], (dt[1] - 1), dt[2]);
    return format(nd, 'MMMM d, yyyy');
};

const DayTripHoldPage = ({history}) => {
    const prefix = window['siteUrl'];
    const confirmationBanner = prefix + '/images/confirmation/banner.jpg';
    const dispatch = useDispatch();
    const {bookingId} = useParams();
    const [booking, setBooking] = useState({})
    const transactions = useSelector(state => state.transactions);
    const step = useSelector(state => state.step);
    const prefixUrl = 'booking/day-trips';
    const historyUrl = useHistory();
    const classes = useStyles();
    const [bookingData, setBookingData] = useState({depositDate: null, difference: null});

    useEffect(() => {
        if (booking?.bookDate && booking?.DepositDate) {
            try {
                const bookingTime = format(parse(booking.bookDate, 'yyyy-MM-dd HH:mm:ss', new Date()), 'HH:mm:ss');
                const depositDate = parse(`${booking.DepositDate} ${bookingTime}`, 'yyyy-MM-dd HH:mm:ss', new Date());
                const difference = differenceInHours(depositDate, new Date());
                setBookingData({depositDate, difference});
            } catch (e) {
                console.error('Error parsing booking dates:', e);
            }
        }
    }, [booking]);

    useEffect(() => {
        dispatch(setStep(3));
        if (Object.keys(booking).length === 0)
            getBooking().catch();
    }, []);

    useEffect(() => {
        dispatch(getActivityList()).then(() => {
            const storedTransactions = sessionStorage.getItem('transactions');
            if (storedTransactions) {
                const parsed = JSON.parse(storedTransactions);
                dispatch({
                    type: SET_SELECTED_EXTRAS,
                    payload: parsed.extra || {}
                });
                dispatch(setTotalActivitiesFH());
            }
        })
    }, [])

    async function getBooking() {
        const {data} = await requestApi(`/activities/booking/get/${bookingId}`);
        if ('status' in data && data['status'] === 'success') {
            if (Object.keys(data['booking']).length > 0) {
                setBooking(data['booking']);
            }
            if (Object.keys(data['transactions']).length > 0)
                sessionStorage.setItem('transactions', JSON.stringify(data['transactions']));
        }
    }

    function goToPayment() {
        historyUrl.push(`/${prefixUrl}/${bookingId}/payment`);
    }

    const goToMyBookings = () => {
        historyUrl.push(`/booking/my-bookings`);
    };


    return (
        <>
            <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Typography color="text.primary">Day Trip Bookings - Hold Page</Typography>
                </Breadcrumbs>
            </GuestBar>

            <Container maxWidth="lg">
                <DayTripStepper/>
                <div style={{marginTop: 50}}/>
                <Grid container spacing={3} sx={{marginBottom: 20}}>
                    <Grid item xs={12} sm={12} md={9}>
                        <Container maxWidth="lg">
                            <Grid container direction="column" spacing={3} alignItems={"center"} justify={"center"}>
                                <Grid item xs>
                                    <Typography variant="h4" component="h4" align="left">
                                        Your booking will be on hold
                                        until <strong>{bookingData.depositDate ? format(bookingData.depositDate, 'MMMM d, yyyy') : ''}</strong><br/><br/>
                                    </Typography>
                                    <Typography variant="h5" component="h5" align="left">
                                        We are holding your booking for {bookingData.difference ?? '--'} hours to make
                                        sure nobody steals your spot. <br/><br/><br/>
                                    </Typography>
                                    {!isWidget &&
                                        <Typography variant="h4" component="h4" align="left">
                                            How to confirm your booking?<br/>
                                        </Typography>
                                    }
                                </Grid>
                                {!isWidget() &&
                                    <Grid item xs container direction="row" spacing={3} alignItems={"center"}
                                          justify={"center"}>
                                        <Grid item xs>
                                            <Button sx={{padding: 0}} variant={'text'} fullWidth
                                                    href={`${window['siteUrl']}booking/my-bookings`}>
                                                <Typography component="h4" variant="h4" align="center" className={clsx({
                                                    [classes.option]: true,
                                                    'holdOption': true
                                                })}>
								<span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
									<PersonOutlined style={{width: 74, fontSize: '7.4rem', color: lightBlue[500]}}/>
								</span>
                                                    <strong>Check my account</strong>
                                                </Typography>
                                            </Button>
                                        </Grid>
                                        <Grid item xs>
                                            <Typography component="h4" variant="h4" align="center"
                                                        className={clsx({[classes.option]: true, 'holdOption': true})}>
								<span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
									<MailOutlined style={{width: 74, fontSize: '7.4rem', color: lightBlue[500]}}/>
								</span>
                                                <strong>Click on the link you received in your mailbox</strong>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs>
                                            <Button
                                                sx={{ padding: 0 }}
                                                variant="text"
                                                fullWidth
                                                href="https://wa.me/+526241299243"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Typography
                                                    component="h4"
                                                    variant="h4"
                                                    align="center"
                                                    className={clsx({ [classes.option]: true, holdOption: true })}
                                                >
                                                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                          <img
                                                              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                                                              alt="WhatsApp"
                                                              style={{ width: 74, height: 74 }}
                                                          />
                                                        </span>
                                                    <strong>Message us on WhatsApp +52 624 129 9243 — Monday to Friday & all boarding days</strong>
                                                </Typography>
                                            </Button>

                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </Container>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3}>
                        <Paper style={{marginTop: 20}}>
                            <Button color={'primary'} variant={'contained'} fullWidth onClick={goToPayment}>
                                Pay Now
                            </Button>
                        </Paper>
                        <Itinerary removable={false}/>
                        <Summary/>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default DayTripHoldPage;
